import { CreateListContractorEmployee, UploadContractorEmployeeFormFile } from "../../../reduxToolkit/Files/FilesApi"; // API calls for uploading files and creating contractor employee lists
import { toast } from "react-toastify"; // Library for toast notifications
import routes from "../../../Routes/routes";
import {errorMsg} from "../../../Apis/functions"; // Application route definitions

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

/**
 * Component that handles uploading contractor employee files and confirming the creation of contractor employee records.
 *
 * @param {object} t - Translation function (i18next).
 * @param {function} dispatch - Redux dispatch function.
 * @param {function} navigate - Navigation function (e.g., from react-router).
 * @param {object} spreadsheetData - Parsed spreadsheet data to upload.
 * @param {object} data - Data to send for creating contractor employee list.
 * @param {function} setUpdate - Function to trigger a UI update or refresh.
 * @param {function} getFormData - Function that returns form data (e.g., `FormData` object).
 * @param {function} isValidFile - Callback for when file upload is successful.
 */
export const CreationErrorsContractorEmployeeApp = ({
                                                        t,
                                                        dispatch,
                                                        navigate,
                                                        spreadsheetData,
                                                        data,
                                                        setUpdate,
                                                        getFormData,
                                                        isValidFile
                                                    }) => {

    // Handles the file upload process
    const handleUploadFile = () => {
        setUpdate(true); // Trigger UI refresh/update

        // Ensure spreadsheet data exists before trying to upload
        if (spreadsheetData) {
            const formData = getFormData(); // Get file/form data for upload

            if (formData) {
                dispatch(UploadContractorEmployeeFormFile(formData))
                    .then(({ payload: { data: { data, success } } }) => {
                        if (success === true) {
                            isValidFile(data); // Call callback with returned data
                        }
                    })
                    .catch(() => {
                        // Show error toast if upload fails
                        toast.error(t('fail_to_upload_file').toUpperCase());
                    });
            }
        } else {
            // Show warning if no file was selected for upload
            toast?.warn(t('there_is_not_file_to_upload').toUpperCase());
        }
    };

    // Handles confirming and saving the contractor employee records
    const handleConfirm = () => {
        dispatch(CreateListContractorEmployee(data)).then(({ payload: { data: { success, code } } }) => {
            if (success === true) {
                toast.success(t('has_been_created_successfully')); // Show success message
                navigate(routes.contractor.searchEmployee); // Navigate to contractor employee search screen
            } else errorMsg(code);
        });
    };

    // Return the functions for use in the component's UI
    return {
        handleConfirm,
        handleUploadFile
    };
};

// Export the component for use in other parts of the application
export default CreationErrorsContractorEmployeeApp;
